import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyMultiple12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTypographyMultiple12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M0 2h9v1.5a.5.5 0 0 1-1 0V3H5v6h1.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H4V3H1v.5a.5.5 0 0 1-1 0zm9 3h3v1h-2v4H9V6H7V5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyMultiple12);
